import React from "react";

export default function Profile() {
  return <div>사용자 프로필 정보입니다.</div>;
}
